import React, { useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Popover,
  useDisclosure,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { TalhoesProps } from "core/features/talhoes/typings/listaEGeojson";
import TrashIcon from "assets/images/icons/trash.svg";
import UploadIcon from "assets/images/icons/upload.svg";
import CloseIcon from "assets/images/icons/close-icon.svg";
import KMLIcon from "assets/images/icons/kml-icon.svg";
import { ModalModeEnum } from "core/features/talhoes/contexts/Talhoes.context";
import { FaCheck } from "react-icons/fa";
import { useUploadKMLCode } from "../../../hooks/useUploadKMLCode";

interface MapEditionModeProps {
  showEditOptions: boolean;
  currentItem?: TalhoesProps;
  showCancelModal: boolean;
  ableToSave: boolean;
  toogleEditOptions: (prop: boolean) => void;
  onCancel: () => void;
  eraseAll: () => void;
  onChangeModalMode: (prop: ModalModeEnum | undefined) => void;
  onOpenModal: () => void;
  onSave: () => void;
}

const MapEditionMode = ({
  showEditOptions,
  currentItem,
  showCancelModal,
  toogleEditOptions,
  onCancel,
  onChangeModalMode,
  onOpenModal,
  onSave,
}: MapEditionModeProps) => {

  const { isOpen, onClose, onOpen } = useDisclosure();
  const { items, onChange, utils } = useUploadKMLCode();
  const [tipVisible, setTipVisible] = useState<boolean>(false);

  function normalizeWKT(wkt: string) {
    const result = wkt.replace(/(MULTIPOLYGON|POLYGON)\s*Z/i, "$1").replace(/ 0([,)])/g, "$1");
    onChange.setCode(result);
  }

  return (
    <>
      {!showEditOptions ? (
        <Button
          width="110px"
          height="45px"
          borderRadius="7px"
          background="white"
          border="2px solid #D9D9D9"
          marginBottom="13px"
          _active={{}}
          _focus={{}}
          _hover={{}}
          marginLeft="10px"
          disabled={!currentItem}
          onClick={() => currentItem && toogleEditOptions(true)}
        >Editar talhão</Button>
      ) : (
        <Flex
          justifyContent="space-between"
          padding="0 10px"
          paddingBottom={"10px"}
        >
          <Box display="flex" gridGap="4px">
            <Button
              background="white"
              border="2px solid #D9D9D9"
              color="gray"
              onClick={showCancelModal ? onCancel : () => toogleEditOptions(false)}
            >Cancelar Edição</Button>

            <Button
              background="white"
              border="2px solid #D9D9D9"
              height="40px"
              padding="16px"
              _active={{}}
              _focus={{}}
              _hover={{}}
              disabled={!showCancelModal && !currentItem?.possuiGeometria}
              onClick={() => {
                onChangeModalMode(ModalModeEnum.delete);
                onOpenModal();
              }}
            >
              <Image src={TrashIcon} style={{ marginRight: 8 }} />
              Apagar
            </Button>

            <Popover isOpen={isOpen} isLazy>
              <PopoverTrigger>
                <Button
                  background="white"
                  border="2px solid #D9D9D9"
                  height="40px"
                  padding="8px"
                  _active={{}}
                  _focus={{}}
                  _hover={{}}
                  onClick={() => {
                    if (isOpen) {
                      return onClose();
                    }
                    return onOpen();
                  }}
                >
                  <Image src={UploadIcon} />
                  Importar Polígono
                </Button>
              </PopoverTrigger>
              <Portal>
                <PopoverContent
                  marginLeft="44%"
                  paddingLeft="22px"
                  width={["419px", "30vw"]}
                  outline={"none"}
                  _focus={{}}
                  _active={{}}
                  padding={"0 22px"}
                >
                  <PopoverHeader
                    fontWeight="medium"
                    color="#676C77"
                    fontSize={"1.1rem"}
                    marginBottom="11px"
                    marginTop="15px"
                  >
                    <Flex justifyContent="space-between">
                      Importar polígono via código WKT
                      <Image
                        src={CloseIcon}
                        width="22px"
                        height="22px"
                        onClick={() => onClose()}
                        cursor="pointer"
                      />
                    </Flex>
                  </PopoverHeader>

                  <PopoverBody>
                    <Flex gridGap="10px" alignItems={"center"}>
                      <Text color="#676C77" fontSize="1rem" fontWeight="medium">
                        Informes as coordenadas
                      </Text>

                      <Text
                        border={"1px solid gray"}
                        width={"15px"}
                        height={"15px"}
                        borderRadius={"50%"}
                        textAlign="center"
                        display="flex"
                        alignItems="center"
                        padding={2}
                        justifyContent="center"
                        transform="rotate(180deg)"
                        onMouseEnter={() => setTipVisible(true)}
                        onMouseLeave={() => setTipVisible(false)}
                      >
                        i
                        <Box
                          position="absolute"
                          top="20px"
                          transform="rotate(-180deg)"
                          height="80px"
                          background="white"
                          minWidth="313px"
                          boxShadow=" 0px 3px 6px #00000029"
                          borderRadius="5px"
                          padding="14px"
                          alignItems="center"
                          opacity={tipVisible ? 1 : 0}
                          transition="all .5s"
                          pointerEvents="none"
                        >
                          <Flex
                            gridGap="12px"
                            alignItems="center"
                            height={"100%"}
                          >
                            <Image src={KMLIcon} />
                            <Box>
                              <Text
                                color="gray"
                                fontSize="15px"
                                fontWeight="medium"
                                textAlign="left"
                              >Coordenadas do tipo WKT</Text>
                              <Text
                                textAlign="left"
                                color="#676C77"
                                fontSize="13px"
                                width="100%"
                              >
                                Inicia com{" "}
                                <strong
                                  style={{
                                    color: "#11A557",
                                    fontWeight: 400,
                                  }}
                                >
                                  "Polygon"
                                </strong>
                                {" "}ou{" "}
                                <strong
                                  style={{
                                    color: "#11A557",
                                    fontWeight: 400,
                                  }}
                                >
                                  "Multipolygon"
                                </strong>
                              </Text>
                            </Box>
                          </Flex>
                        </Box>
                      </Text>
                    </Flex>
                    <Textarea
                      _focus={{}}
                      _active={{}}
                      resize={"none"}
                      border="1px solid #707070 !important"
                      height="115px"
                      placeholder="Polygon ((-57.95180770507789703 -14.37468791627915365, -57.95174379140602383 -14.37467895534164697, -57.95171651367164145 -14.37467982995101679, -57.95180770507789703 -14.37468791627915365))"
                      fontSize="0.8rem"
                      value={items.code}
                      onChange={(e) => normalizeWKT(e.target.value.trim())}
                    ></Textarea>
                    <Flex
                      justifyContent="space-between"
                      alignItems="center"
                      marginTop="23px"
                    >
                      <Button
                        _active={{}}
                        _focus={{}}
                        background="none"
                        fontWeight="medium"
                        fontSize="14px"
                        padding={0}
                        onClick={onChange.handleClear}
                      >LIMPAR</Button>
                      <Button
                        _active={{}}
                        _focus={{}}
                        fontWeight="medium"
                        background="#11A557 0% 0% no-repeat padding-box"
                        color="white"
                        height="33px"
                        fontSize="13px"
                        onClick={() => {
                          onClose();
                          utils.applyKMLCoords();
                        }}
                      >
                        <FaCheck
                          style={{
                            marginRight: "8px",
                          }}
                        />{" "}
                        APLICAR
                      </Button>
                    </Flex>
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          </Box>
          <Box>
            <Button
              background="green"
              color="white"
              marginRight="10px"
              onClick={onSave}
            >Salvar</Button>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default MapEditionMode;
